import Sdk from 'casdoor-js-sdk';
import { sdkConfig, wsBaseHref } from '../AppConfig';

export const casdoorSDK = new Sdk(sdkConfig);
export const appServerUrl = wsBaseHref;

export const isLoggedIn = () => {
    const token = localStorage.getItem("token");
    return token !== null && token.length > 0;
};

export const setToken = (token) => {
    localStorage.setItem("token", token);
};

export const getToken = () => {
  return localStorage.getItem("token");
}

export const goToLink = (link) => {
    window.location.href = link;
};

export const getRedirectUrl = () => {
    return fetch(`${wsBaseHref}/redirect-url`, {
        method: "GET",
    }).then((res) => res.json());
};

export const getUserinfo = () => {
    return fetch(`${wsBaseHref}/userInfo`, {
        method: "GET",
        headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    }).then((res) => res.json());
};

export const isAdmin = () => {
  getUserinfo()
      .then(
        (result) => {
          console.warn('arrivato alla then di isAdmin!', result.payLoad.isAdmin);
          return result.payLoad.isAdmin;
        },
        (error) => {
          return false;
        }
      )
}

export function isReferral(userInfo) {
  if (userInfo && userInfo.groups && userInfo.groups.length > 0) {
    if (userInfo.groups.indexOf("referrals") > -1) {
      return true;
    }
    return false;
  }
  return false;
}

export const logout = () => {
    localStorage.removeItem("token");
};

export const showMessage = (message) => {
    alert(message);
};

export function getSignupUrl() {
    return casdoorSDK.getSignupUrl();
  }
  
  export function getSigninUrl() {
    return casdoorSDK.getSigninUrl();
  }
  
  export function getUserProfileUrl(userName, account) {
    return casdoorSDK.getUserProfileUrl(userName, account);
  }
  
  export function getMyProfileUrl(account) {
    return casdoorSDK.getMyProfileUrl(account);
  }
  
  export function getMyResourcesUrl(account) {
    return casdoorSDK.getMyProfileUrl(account).replace("/account?", "/resources?");
  }
  
  export function signin() {
    return casdoorSDK.signin(appServerUrl);
  }